import { render, staticRenderFns } from "./TaskController.vue?vue&type=template&id=543cdbd5"
import script from "./TaskController.vue?vue&type=script&lang=js"
export * from "./TaskController.vue?vue&type=script&lang=js"
import style0 from "./TaskController.vue?vue&type=style&index=0&id=543cdbd5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports